import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    container: {
      '@media (max-width: 1200px)': {
        position: 'fixed',
        zIndex: 8,
        left: '0',
        right: '0',
        top: '50px',
        padding: '15px 0 0 0',
        background: 'linear-gradient(#F0F6FE 75%, rgba(240, 246, 254, 0) 100%)'
      },
      '@media (min-width: 769px) and (max-width: 1200px)': {
        top: '60px',
        left: (props: { isPublicShop: boolean }) => {
          if (props.isPublicShop) return '0';
          if (!props.isPublicShop) return '220px';
        }
      }
    },
    root: {
      display: 'flex',
      padding: '0 22px 0 22px',
      alignItems: 'flex-start',
      gap: '20px',
      marginBottom: '10px',
      overflowX: 'scroll',
      overflowY: 'visible',
      '@media (max-width: 1200px)': {
        '&::-webkit-scrollbar': {
          width: '0'
        },
        overflow: '-moz-scrollbars-none'
      },
      '@media (min-width: 1200px)': {
        overflowX: 'visible',
        padding: '0'
      },
      '@media (min-width: 769px) and (max-width: 1200px)': {
        paddingLeft: (props: { isPublicShop: boolean }) => {
          if (props.isPublicShop) return '40px';
          if (!props.isPublicShop) return '75px';
        }
      }
    },
    mobileFiltersModal: {
      marginBottom: '15px',
      justifyContent: 'center'
    },
    overflow: {
      overflow: 'visible',
      paddingBottom: '20px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
